import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';

/**
 * @deprecated use `Banner` component instead
 *
 * @subcomponent EmbeddedTextHero
 */ const EmbeddedTextHeroLink = deprecatedComponent({
    displayName: 'EmbeddedTextHeroLink',
    description: 'Use `Banner` component instead.',
    root: createComponent({
        displayName: 'EmbeddedTextHeroLink',
        root: 'a',
        propConfig: {
            classNames: [
                'swan-embedded-text-hero-link'
            ]
        }
    })
});

export { EmbeddedTextHeroLink };
